import React, { useState } from "react";
import { Link } from "react-router-dom";

// We are using this
export const NotifyBar = ({ endDate, description, btnUrl = "/", btnName, barClass="bg-notify-color" }) => {
  const [visible, setVisible] = useState(true);
  // const endDate = process.env.REACT_APP_OFFER_END_DATE;
  // const description = process.env.REACT_APP_OFFER_DESCRIPTION;

  if (!visible) return null;
  return (
    <div
      className={`alert ${barClass} alert-dismissible fade show`}
      role="alert"
    >
      <p className="m-0 notification-container">
        <strong>{description}</strong> <strong>Hurry! Offer ends on {endDate}.</strong> <span className=" pl--5"> <Link to={btnUrl} className="edu-btn btn-small btn-shade-secondary">{btnName}</Link></span>
      </p>
      <button
        type="button"
        className="btn-close btn-close-white"
        data-bs-dismiss="alert"
        aria-label="Close"
        onClick={() => setVisible(false)}
      ></button>
    </div>
  );
};


